import { getTicketsDataUseCase } from "@domains/features/TicketPortal/useCases/ticketsDataUseCase";
import { createTicketUseCase } from "@domains/features/TicketPortal/useCases/createTicketUseCase";
export default (repositories) => {
    return {
        ticketData: {
            ticketsDetails: new getTicketsDataUseCase(repositories.ticketData),
            createTicketDetails: new createTicketUseCase(repositories.ticketData)
        },
    };
};
